<template>
	<div id="app">
		<p id="logo">
			<img src="@/assets/img/Otelico-logo-text-bleu.png" />
		</p>
		<Form />
	</div>
</template>

<script>
import Form from "./components/Form.vue";

export default {
	name: "app",
	components: {
		Form
	}
};
</script>

<style lang="scss">
@import "./assets/sass/main.scss";
</style>
